<template>
  <a
    class="banner"
    href="https://coinhold.emcd.io/"
    :class="`banner--${props.size}`"
    @click.prevent="handleClick"
  >
    <div class="banner__text">
      <Text
        v-if="props.size === 'sm'"
        pattern="body2"
        :weight="600"
        :height="125"
        color="#0a0a0a"
        class="banner__text--title"
      >
        <span v-html="$t('BannerTitle')" />
      </Text>
      <Text
        v-else
        pattern="body2"
        :weight="600"
        :height="125"
        color="#000"
        class="banner__text--title"
      >
        <span v-html="$t('BannerFullTitle')" />
      </Text>
      <Text
        pattern="body3"
        class="w-[250px] banner__text--subtitle"
        :weight="400"
        :height="140"
        color="#4d4d4d"
      >
        {{ $t("BannerSubtitle") }}
      </Text>
      <span class="banner_link">
        {{ $t("BannerLink") }}
      </span>
    </div>
  </a>
</template>

<script setup>
import { Text } from "@/shared/ui";
import { useStore } from "vuex";
import { computed } from "vue";

// Props
const props = defineProps({
  value: {
    type: Number,
    default: 0,
  },
  symbol: {
    type: String,
    default: "",
  },
  size: {
    type: String,
    validator: (value) => ["lg", "sm"].includes(value),
    default: "lg",
  },
});

const store = useStore();

const getUserData = computed(() => store.getters["user/getUserData"]);

// Methods
const handleClick = () => {
  window.emcd.AnalyticsService.track("click", {
    event_type: "click",
    product: "explorer",
    screen: "banner",
    button_name: "banner_click",
    utm_source: "banner_explorer",
    user_id: getUserData.value ? getUserData.value.userData.user_id : null,
  });
  window.open("https://coinhold.emcd.io/", "_blank");
};
</script>

<style lang="scss" scoped>
.banner {
  display: flex;
  position: relative;
  overflow: hidden;
  flex-direction: column;
  gap: 6px;
  border-radius: 10px;
  background: #fff;

  &__text {
    padding: 14px 18px 12px;
    z-index: 2;
  }

  &_link {
    color: #8f42ff;
    font-size: 12px;
    font-style: normal;
    font-weight: 700;
    line-height: 140%;
    text-decoration: none;
    margin-top: 8px;

    &:hover {
      color: var(--brand-hover);
    }

    &:active {
      color: var(--brand-fill-hover);
    }
  }

  &--sm:before {
    content: "";
    position: absolute;
    width: 100%;
    height: 100%;
    background-image: url(@/features/Banner/images/coins.png);
    background-repeat: no-repeat;
    background-position-x: 115%;
    background-size: 147px;
    z-index: 1;

    @media (width < 1024px) {
      background-position-x: 100%;
    }

    @media (width < 576px) {
      background-size: 147px;
      background-position-x: 110%;
    }
  }

  .banner__text--title {
    margin-bottom: 6px;
  }

  .banner__text--subtitle {
    margin-bottom: 17px;
  }

  &--lg {
    .banner__text--title {
      font-size: 24px;
    }

    .banner__text--subtitle {
      font-size: 14px;
    }

    .banner_link {
      font-size: 14px;
    }

    @media (width < 768px) {
      .banner__text--title {
        font-size: 14px;
        width: 80%;
      }

      .banner__text--subtitle {
        font-size: 12px;
      }

      .banner_link {
        font-size: 12px;
      }
    }
  }

  &--lg:before {
    content: "";
    position: absolute;
    width: 100%;
    height: 100%;
    background-image: url(@/features/Banner/images/coins.png);
    background-repeat: no-repeat;
    background-position-x: 100%;
    background-position-y: 6%;
    background-size: 340px;
    z-index: 1;

    @media (width < 768px) {
      background-size: 140px;
    }
  }
}
</style>
